import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {TdoSubnavItemModel} from '../../controls/tdo-subnav/models/tdo-subnav-item.model';
import {TdoImagingService} from '../../imaging/tdo-imaging.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {Globals} from '../../../globals';
import {UiService} from '../../../services/ui.service';
import {AuthenticationService} from '../../../modules/auth/services/authentication.service';
import {UserRoleEnum} from '../../../models/enum/user-role.enum';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DialogService} from '../../../services/dialog.service';
import {MessagingService} from '../../../services/messaging.service';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {SchedulingService} from '../../../modules/scheduling/scheduling.service';
import {DataAppointmentModel} from '../../../models/appointments/data-appointment.model';
import {PatientCaseViewDataModel} from '../../../models/patient/patient-case-view-data.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {CaseService} from '../../../services/case.service';
import {UserService} from '../../../services/user.service';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {PatientFlagDataModel} from '../../../models/patient/patient-flag-data.model';
import {AppointmentFlagDataModel} from '../../../models/appointments/appointment-flag-data.model';
import {FlagsService} from "../../../services/flags.service";
import {
  AllPatientAppointmentsDialogComponent
} from "../../../dialog/all-patient-appointments-dialog/all-patient-appointments-dialog.component";
import {
  PatientAppointmentDetailDialogComponent
} from "../../../dialog/patient-appointment-detail-dialog/patient-appointment-detail-dialog.component";
import {TdoNoteQueryModel} from "../../controls/tdo-notes/models/tdo-note-query.model";
import {NotesService} from "../../../services/notes.service";
import {FolderSelectionDialogComponent} from '../../../dialog/folder-selection-dialog/folder-selection-dialog.component';
import {TdoOrganizerComponent} from '../../controls/tdo-organizer/tdo-organizer.component';

@Component({
  standalone: false,
  selector: 'app-home-subnav-info-view',
  templateUrl: './home-subnav-info-view.component.html',
  styleUrls: ['./home-subnav-info-view.component.scss']
})
export class HomeSubnavInfoViewComponent implements OnInit {
  @ViewChild('main') mainContainer: ElementRef;
  //@ViewChildren(TdoSubnavItemComponent) navItems: QueryList<TdoSubnavItemComponent>;
  @Input() isExpanded: boolean = false;

  //allNavItems: TdoSubnavItemModel[] = [];
  currentRoute: string;
  width = 0;
  imagingNavModels: TdoSubnavItemModel[] = [];
  selectedAppointment: DataAppointmentModel;
  appointments: DataAppointmentModel[] = [];
  currentCase: PatientCaseViewDataModel;
  caseStatusEnums: EnumValidValueItemModel[] = [];
  users: TdoUserConfigurationModel[] = [];
  usersTDO: TdoUserConfigurationModel[] = [];
  patientFlags: PatientFlagDataModel[] = [];
  appointmentFlags: AppointmentFlagDataModel[] = [];

  constructor(private router: Router,
              private noteService: NotesService,
              private dialogService: DialogService,
              private uiService: UiService,
              private authenticationService: AuthenticationService,
              private localStorageService: LocalStorageService,
              private globals: Globals,
              private dialog: MatDialog,
              private staticDataService: StaticDataService,
              private schedulingService: SchedulingService,
              private caseService: CaseService,
              private userService: UserService,
              private messagingService: MessagingService) {
    this.currentRoute = router.url;
  }

  ngOnInit(): void {
    this.userService.getUsers(this.globals.TDOCID).subscribe((userRes) => {
      this.users = userRes;
    });

    this.userService.getAllUsers(this.globals.TDOCID).subscribe((userRes) => {
      this.usersTDO = userRes;
    });

    if (this.staticDataService.isReady) {
      this.caseStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseStatus');
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.caseStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseStatus');
        }
      });
    }

    this.messagingService.componentMessageCall.subscribe((response) => {
      switch (response.event) {
        case MessagingConstants.CASE_CHANGED_EVENT:
          this.currentCase = response.data;
          this.appointments = [];

          if (this.currentCase?.Case?.PatientCaseId) {
            this.schedulingService.getAppointmentsByCase(this.currentCase?.Case?.PatientCaseId).subscribe((res) => {
              this.appointments = res;
            });
          }
          break;
      }
    });
  }

  onAppointmentClick(appointment: DataAppointmentModel) {
    this.selectedAppointment = appointment;
    const noteQuery = new TdoNoteQueryModel();
    noteQuery.patientId = this.globals.currentPatientId;
    noteQuery.objectId = this.selectedAppointment.AppointmentId;
    noteQuery.parentObjectName = 'dataAppointment';

    this.noteService.changeNoteQuery(noteQuery);
  }

  onAllAppointmentsClick() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = this.appointments;
    this.dialog.open(AllPatientAppointmentsDialogComponent, config);
  }


  onCaseStatusChange(event: EnumValidValueItemModel) {
    if(event.ValidValueItemId) {
      this.currentCase.Case.enumCaseStatusID = event.ValidValueItemId;
      this.caseService.updateCaseStatus(this.currentCase.Case.PatientCaseId, event.ValidValueItemId).subscribe((res) => {
      });
    }
  }

  getUsername(StatusOn: string) {
    // console.log("getUsername: ", StatusOn);
    // console.log("getUserName users:", this.users);
    if (this.users && this.users.length > 0) {
      const user = this.users.find(p => p.UserID === StatusOn);
      if (user) {
        return user.FirstName + ' ' + user.LastName;
      }
    }

    return '';
  }

  onAppointmentInfoClick(appointment: DataAppointmentModel) {
    const config = new MatDialogConfig();
    config.data = appointment;
    config.panelClass = 'dialog';
    this.dialog.open(PatientAppointmentDetailDialogComponent, config);
  }

  onOpenNotificationToFrontDialog() {
    this.router.navigateByUrl('landing/notes-to-front');

  }

  onOpenFolderSelector() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';


    config.data = {
      FromTable: 'FolderPresentation',
    };
    this.dialog.open(FolderSelectionDialogComponent, config).afterClosed().subscribe((result) => {
      if (result) {
        const config2 = new MatDialogConfig();

        config2.height = '800px';
        config2.width = '1300px';
        config2.data = {
          PickList: 'true',
          OperationMode: 'FolderPresentation',
          FolderToBrowse: result.id,
        };
        this.dialog.open(TdoOrganizerComponent, config2).afterClosed().subscribe((result2) => {
          if (result2) {
            // return
          }
        });
      }
    });
  }

  isHasRole(val: string) {
    switch (val) {
      case 'communication':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Communications);
      case 'scheduler':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Scheduler);
      case 'noteToFront':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.NoteToFront);
    }

    return false;
  }
}
